import React from 'react';
import Text from '@loggi/ui/components/text';

function haystackComponent(bold, rest) {
  const ellipsis = {
    lines: 1,
    mode: 'tail'
  };

  return (
    <Text ellipsis={ellipsis}>
      <Text bold>{bold}</Text>
      {rest}
    </Text>
  );
}

export default function haystack(text, needle) {
  const NOT_REGEX_SAFE_CHARS = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/gim;
  const replace = __NATIVE__ ? '$&' : '\\$&'; // isnt necessary to escape in native
  needle = needle.trim();
  needle = needle.replace(NOT_REGEX_SAFE_CHARS, replace);

  if (__NATIVE__) {
    const regex = new RegExp(`^(${needle})`, 'gi');
    const exists = regex.test(text);
    const rest = exists ? text.replace(regex, '') : text;
    const bold = exists ? text.substring(0, needle.length) : '';
    return haystackComponent(bold, rest);
  }

  // TODO(@renatoagds) remove this and use native approach
  needle = needle
    .split(' ')
    .filter(str => str.trim() !== '')
    .reduce((str, val) => {
      str += `${val}|`;
      return str;
    }, '')
    .slice(0, -1);

  const regex = new RegExp(`(${needle})`, 'gi');

  return text.replace(regex, '<b>$1</b>');
}
